import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Address_Interface, Empty_Address_Interface } from 'src/app/Interface/Address_Interface';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Customer_Interface, Empty_Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { Empty_KarshnasMasol_Interface, KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FeildActivityService } from 'src/app/Service/FeildActivity/FeildActivity.service';
import { ProvinceService } from 'src/app/Service/Province/Province.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { AddressTitleService } from 'src/app/Service/AddressTitle/AddressTitle.service';

@Component({
  selector: 'app-CustomerAdd',
  templateUrl: './CustomerAdd.component.html',
  styleUrls: ['./CustomerAdd.component.scss']
})
export class CustomerAddComponent implements OnInit {

  constructor(
    private province_Service:ProvinceService,
    private Alerify:AlertifyService,
    private Nav_Service:NavService,
    private AddressTitle_Service:AddressTitleService,
    private FeildActivity_Service:FeildActivityService,
    private Customer_Service:CustomerService,
  ) { }

  ngOnInit() {
    this.Nav_Service.CheckValidPage(16).subscribe(
      data=>{
        this.Read_Address_Title()

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

    this.AddNewCustomer=new FormGroup({
      id :new FormControl(0),
      Code:new FormControl(null,Validators.required),
      ShenasehMeli:new FormControl(null),
      Name:new FormControl(null,Validators.required),
      Name_En:new FormControl(null),
      ProvinceId:new FormControl("0"),
      CityId:new FormControl("0"),
      FeildActivity:new FormControl("0"),
      Foreign:new FormControl("0"),
      ShomarehSabt:new FormControl(null,Validators.pattern('^[0-9]{11}$')),
      CodeEghtesadi:new FormControl(null,Validators.pattern('^[0-9]{12}$')),
      CodeMeli:new FormControl(null,Validators.pattern('^[0-9]{9}$')),

      ModirAmelName: new FormControl(null),
      ModirAmelMobile:new FormControl(null),
      //ModirAmelMobile:new FormControl(Validators.required,Validators.pattern('^[0-9]{10}$')),
      ModirAmelTel:new FormControl(null),
      ModirAmelDakheli:new FormControl(null),
      ModirAmelEmail:new FormControl(null,Validators.email),
    })

    this.AddressCustomer=new FormGroup({
      id :new FormControl(),
      title_id:new FormControl("0",Validators.required),
      address:new FormControl(null),
      codepost:new FormControl(null,Validators.required),
      sandoghpost:new FormControl(null),
      certificateAddress:new FormControl(null,[Validators.required,Validators.maxLength(50)]),
      certificateAddress_En:new FormControl(null,[Validators.maxLength(50)]),
      pishShomareh:new FormControl(null),
      Tel:new FormControl(null),
      Email:new FormControl('',Validators.email),
      Dakheli:new FormControl(null),
      Fax:new FormControl(null),
      Dsc:new FormControl(null),
    })

  }

  //#region FeildActivity

  DataList_FeildActivity:Array<FeildActivity_Interface>=[]
  ReadData_FeildActivity(){
    this.FeildActivity_Service.GetRecord().subscribe(
      data=>{
        this.DataList_FeildActivity=data
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  RabetMasolCustomer_FeildActivity:Array<General_Interface>=[]
  OnAdd_RabetMasolCustomer_FeildActivity(){

    var Exited:boolean=false
    for  (let item of this.RabetMasolCustomer_FeildActivity)
    {
      if(item.id==Number(this.get_Form_FeildActivity().value))
      {
        Exited=true;
        break
      }
    }

    if(this.RabetMasolCustomer_FeildActivity.length==3)
    {
      this.Alerify.ErrorMessage("امکان ثبت بیش از 3 زمینه فعالیت نیست!")
    }
    else if(Exited)
    {
      this.Alerify.ErrorMessage("زمینه فعالیت در لیست وجود دارد")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.id = Number(this.get_Form_FeildActivity().value)
      temp.title=this.Get_Title_FeildActivity(temp.id)
      this.RabetMasolCustomer_FeildActivity.push(temp)


      this.get_Form_FeildActivity().setValue("0")
      this.Alerify.SuccessMessage("زمینه فعالیت در لیست ثبت شد")
    }
  }

  RabetMasolCustomer_FeildActivity_Delete(id){
    this.RabetMasolCustomer_FeildActivity.splice(id,1)
    this.Alerify.SuccessMessage("زمینه فعالیت از لیست حذف شد")
  }

  Get_Title_FeildActivity(id:Number)
  {
    for(let item of this.DataList_FeildActivity)
    {
      if(item.id==id)
      {
        return item.title
      }
    }
    return "";
  }

  //#endregion

  //#region  Form Add

  AddNewCustomer:FormGroup;

  get_Form_id(){
    return this.AddNewCustomer.get('id') as FormControl;
  }


  get_Form_Code(){
    return this.AddNewCustomer.get('Code') as FormControl;
  }


  get_Form_Name(){
    return this.AddNewCustomer.get('Name') as FormControl;
  }

  get_Form_Name_En(){
    return this.AddNewCustomer.get('Name_En') as FormControl;
  }

  get_Form_ShenasehMeli(){
    return this.AddNewCustomer.get('ShenasehMeli') as FormControl;
  }

  get_Form_Foreign(){
    return this.AddNewCustomer.get('Foreign') as FormControl;
  }

  get_Form_ProvinceId(){
    return this.AddNewCustomer.get('ProvinceId') as FormControl;
  }

  get_Form_CityId(){
    return this.AddNewCustomer.get('CityId') as FormControl;
  }

  get_Form_FeildActivity(){
    return this.AddNewCustomer.get('FeildActivity') as FormControl;
  }

  get_Form_ShomarehSabt(){
    return this.AddNewCustomer.get('ShomarehSabt') as FormControl;
  }

  get_Form_CodeEghtesadi(){
    return this.AddNewCustomer.get('CodeEghtesadi') as FormControl;
  }

  get_Form_CodeMeli(){
    return this.AddNewCustomer.get('CodeMeli') as FormControl;
  }

  get_Form_ModirAmelName(){
    return this.AddNewCustomer.get('ModirAmelName') as FormControl;
  }

  get_Form_ModirAmelMobile(){
    return this.AddNewCustomer.get('ModirAmelMobile') as FormControl;
  }

  get_Form_ModirAmelTel(){
    return this.AddNewCustomer.get('ModirAmelTel') as FormControl;
  }

  get_Form_ModirAmelDakheli(){
    return this.AddNewCustomer.get('ModirAmelDakheli') as FormControl;
  }

  get_Form_ModirAmelEmail(){
    return this.AddNewCustomer.get('ModirAmelEmail') as FormControl;
  }




  //#endregion

  //#region Province

  DataList_Province:Array<General_Interface>=[]
  DataList_City:Array<General_Interface>=[]

  Read_Service_Province(id:string){
    this.province_Service.GetRecord(id).subscribe(
      data=>{
        if(id=="")
        {
          this.DataList_Province=data
          this.ReadData_FeildActivity()
        }
        else{
          this.DataList_City=data
        }
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  ProvinceChange(){
    if(this.get_Form_ProvinceId().value=="0")
    {
      this.DataList_City=[]
    }
    else{
      this.get_Form_CityId().setValue("0")
      this.Read_Service_Province(this.get_Form_ProvinceId().value)
    }
  }


  //#endregion

  //#region  جدول کارشناس مسئول

  DataList_KarshnasMasol:Array<KarshnasMasol_Interface>=[]

  set_KarshnasMasol(model:Array<KarshnasMasol_Interface>)
  {
    this.DataList_KarshnasMasol=model
  }

  //#endregion

  //#region فرم آدرس

  AddressCustomer:FormGroup;

  get_Form_AddressCustomer_id(){
    return this.AddressCustomer.get('id') as FormControl;
  }

  get_Form_AddressCustomer_title_id(){
    return this.AddressCustomer.get('title_id') as FormControl;
  }

  get_Form_AddressCustomer_address(){
    return this.AddressCustomer.get('address') as FormControl;
  }

  get_Form_AddressCustomer_codepost(){
    return this.AddressCustomer.get('codepost') as FormControl;
  }

  get_Form_AddressCustomer_sandoghpost(){
    return this.AddressCustomer.get('sandoghpost') as FormControl;
  }

  get_Form_AddressCustomer_pishShomareh(){
    return this.AddressCustomer.get('pishShomareh') as FormControl;
  }

  get_Form_AddressCustomer_certificateAddress(){
    return this.AddressCustomer.get('certificateAddress') as FormControl;
  }

  get_Form_AddressCustomer_certificateAddress_En(){
    return this.AddressCustomer.get('certificateAddress_En') as FormControl;
  }

  get_Form_AddressCustomer_Tel(){
    return this.AddressCustomer.get('Tel') as FormControl;
  }

  get_Form_AddressCustomer_Email(){
    return this.AddressCustomer.get('Email') as FormControl;
  }

  get_Form_AddressCustomer_Dakheli(){
    return this.AddressCustomer.get('Dakheli') as FormControl;
  }

  get_Form_AddressCustomer_Fax(){
    return this.AddressCustomer.get('Fax') as FormControl;
  }

  get_Form_AddressCustomer_Dsc(){
    return this.AddressCustomer.get('Dsc') as FormControl;
  }


  AddressCustomer_Tel:Array<General_Interface>=[]
  OnAdd_AddressCustomer_Tel(){

    var Exited:boolean=false
    for  (let item of this.AddressCustomer_Tel)
    {
      if(item.title==this.get_Form_AddressCustomer_Tel().value)
      {
        Exited=true;
        break
      }
    }

    if(this.AddressCustomer_Tel.length==3)
    {
      this.Alerify.ErrorMessage("امکان ثبت بیش از 3 تلفن نیست!")
    }
    else if(Exited)
    {
      this.Alerify.ErrorMessage("تلفن در لیست وجود دارد")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.title=this.get_Form_AddressCustomer_Tel().value
      this.AddressCustomer_Tel.push(temp)


      this.get_Form_AddressCustomer_Tel().setValue("")
      this.Alerify.SuccessMessage("تلفن در لیست ثبت شد")
    }
  }

  AddressCustomer_Tel_Delete(id){
    this.AddressCustomer_Tel.splice(id,1)
    this.Alerify.SuccessMessage("ایمیل از لیست حذف شد")
  }

  AddressCustomer_Email:Array<General_Interface>=[]
  OnAdd_AddressCustomer_Email(){

    var Exited:boolean=false
    for  (let item of this.AddressCustomer_Email)
    {
      if(item.title==this.get_Form_AddressCustomer_Email().value)
      {
        Exited=true;
        break
      }
    }

    if(this.AddressCustomer_Email.length==3)
    {
      this.Alerify.ErrorMessage("امکان ثبت بیش از 3 ایمیل نیست!")
    }
    else if(Exited)
    {
      this.Alerify.ErrorMessage("ایمیل در لیست وجود دارد")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.title=this.get_Form_AddressCustomer_Email().value
      this.AddressCustomer_Email.push(temp)


      this.get_Form_AddressCustomer_Email().setValue("")
      this.Alerify.SuccessMessage("ایمیل در لیست ثبت شد")
    }
  }

  AddressCustomer_Email_Delete(id){
    this.AddressCustomer_Email.splice(id,1)
    this.Alerify.SuccessMessage("ایمیل از لیست حذف شد")
  }


  //#endregion

  //#region آدرس

  DataList_Address_Title:Array<General_Interface>=[]

  Read_Address_Title(){
    this.Proccesing_OnSubmitForm=true
    this.AddressTitle_Service.GetActiveList().subscribe(
      data=>{
        this.Proccesing_OnSubmitForm=false
        this.Read_Service_Province("")
        this.DataList_Address_Title=data
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  DataList_Address:Array<Address_Interface>=[]
  OnSubmit_AddressForm(){

    if(this.get_Form_AddressCustomer_title_id().value=="0")
    {
      this.Alerify.ErrorMessage("عنوان آدرس را انتخاب نمائید")
    }
    else if(this.AddressCustomer_Tel.length==0)
    {
      this.Alerify.ErrorMessage("حداقل یک تلفن وارد نمائید")
    }
    else{
      if(this.AddressForm_Edit_Id==-1)
        {

          if(this.DataList_Address.length<100)
          {
            var temp:Address_Interface=Empty_Address_Interface()
            temp.id=0
            temp.title_id=this.get_Form_AddressCustomer_title_id().value
            temp.title = this.Find_Address_Title(temp.title_id)+''
            temp.address=this.get_Form_AddressCustomer_address().value
            temp.codepost=this.get_Form_AddressCustomer_codepost().value
            temp.sandoghpost=this.get_Form_AddressCustomer_sandoghpost().value
            temp.pishShomareh=this.get_Form_AddressCustomer_pishShomareh().value
            temp.certificateAddress=this.get_Form_AddressCustomer_certificateAddress().value
            temp.certificateAddress_en=this.get_Form_AddressCustomer_certificateAddress_En().value
            temp.tel=this.AddressCustomer_Tel
            temp.email=this.AddressCustomer_Email
            temp.dakheli=this.get_Form_AddressCustomer_Dakheli().value
            temp.fax=this.get_Form_AddressCustomer_Fax().value
            temp.dsc=this.get_Form_AddressCustomer_Dsc().value


            this.AddressCustomer_Tel=[]
            this.AddressCustomer_Email=[]
            this.DataList_Address.push(temp)

            this.Alerify.SuccessMessage("آدرس  به لیست اضافه شد")
          }
          else{
            this.Alerify.ErrorMessage("امکان ثبت پیش از 100 آدرس نیست!")
          }
      }
      else{

          this.DataList_Address[this.AddressForm_Edit_Id].id=this.get_Form_AddressCustomer_id().value
          this.DataList_Address[this.AddressForm_Edit_Id].title_id=this.get_Form_AddressCustomer_title_id().value
          this.DataList_Address[this.AddressForm_Edit_Id].title=this.Find_Address_Title(this.DataList_Address[this.AddressForm_Edit_Id].title_id)+''
          this.DataList_Address[this.AddressForm_Edit_Id].address=this.get_Form_AddressCustomer_address().value
          this.DataList_Address[this.AddressForm_Edit_Id].codepost=this.get_Form_AddressCustomer_codepost().value
          this.DataList_Address[this.AddressForm_Edit_Id].sandoghpost=this.get_Form_AddressCustomer_sandoghpost().value
          this.DataList_Address[this.AddressForm_Edit_Id].pishShomareh=this.get_Form_AddressCustomer_pishShomareh().value
          this.DataList_Address[this.AddressForm_Edit_Id].certificateAddress=this.get_Form_AddressCustomer_certificateAddress().value
          this.DataList_Address[this.AddressForm_Edit_Id].certificateAddress_en=this.get_Form_AddressCustomer_certificateAddress_En().value
          this.DataList_Address[this.AddressForm_Edit_Id].tel=this.AddressCustomer_Tel
          this.DataList_Address[this.AddressForm_Edit_Id].email=this.AddressCustomer_Email
          this.DataList_Address[this.AddressForm_Edit_Id].dakheli=this.get_Form_AddressCustomer_Dakheli().value
          this.DataList_Address[this.AddressForm_Edit_Id].fax=this.get_Form_AddressCustomer_Fax().value
          this.DataList_Address[this.AddressForm_Edit_Id].dsc=this.get_Form_AddressCustomer_Dsc().value

          this.AddressCustomer_Tel=[]
          this.AddressCustomer_Email=[]
          this.Alerify.SuccessMessage("آدرس ویرایش شد")
          this.AddressForm_Edit_Id=-1
      }

      this.AddressCustomer.reset();
      this.get_Form_AddressCustomer_title_id().setValue("0")
    }

  }

  Find_Address_Title(id:number)
  {
    for(let item of this.DataList_Address_Title)
    {
      if(item.id==id)
      {
        return item.title
      }
    }
    return ""
  }

  AddressForm_Delete(id){
    this.DataList_Address.splice(id,1)
    this.Alerify.SuccessMessage(" حذف شد")
  }

  AddressForm_Edit_Id:number=-1
  AddressForm_Edit(id){
    this.AddressForm_Edit_Id=id

    var temp=this.DataList_Address[id]

    this.get_Form_AddressCustomer_id().setValue(temp.id)
    this.get_Form_AddressCustomer_title_id().setValue(temp.title_id)
    this.get_Form_AddressCustomer_address().setValue(temp.address)
    this.get_Form_AddressCustomer_codepost().setValue(temp.codepost)
    this.get_Form_AddressCustomer_sandoghpost().setValue(temp.sandoghpost)
    this.get_Form_AddressCustomer_pishShomareh().setValue(temp.pishShomareh)
    this.get_Form_AddressCustomer_certificateAddress().setValue(temp.certificateAddress)
    this.get_Form_AddressCustomer_certificateAddress_En().setValue(temp.certificateAddress_en)
    this.get_Form_AddressCustomer_Dakheli().setValue(temp.dakheli)
    this.get_Form_AddressCustomer_Fax().setValue(temp.fax)
    this.get_Form_AddressCustomer_Dsc().setValue(temp.dsc)


    this.AddressCustomer_Tel=temp.tel
    this.AddressCustomer_Email=temp.email


  }

  AddressForm_Edit_Cancel(){
    this.AddressForm_Edit_Id=-1
    this.AddressCustomer.reset();
  }

  //#endregion

  Proccesing_OnSubmitForm:boolean=false
  OnSubmitForm(){

    var Karshnas_Masol_Mobile:number=-1
    var Karshnas_Masol_Email:number=-1
    for(let item of this.DataList_KarshnasMasol)
    {
      if(!item.mobile && this.get_Form_Foreign().value=='0')
      {
        Karshnas_Masol_Mobile=this.DataList_KarshnasMasol.indexOf(item)
        break
      }

      if(item.Email.length == 0 && this.get_Form_Foreign().value=='1')
      {
        Karshnas_Masol_Email=this.DataList_KarshnasMasol.indexOf(item)
        break
      }
    }


    if(this.get_Form_CityId().value=="0"){
      this.Alerify.ErrorMessage("شهر را انتخاب کنید")
    }
    else if(Karshnas_Masol_Mobile>-1){
      this.Alerify.ErrorMessage("تلفن همراه کارشناس ردیف "+(Karshnas_Masol_Mobile+1)+" را وارد نمائید")
    }
    else if(Karshnas_Masol_Email>-1){
      this.Alerify.ErrorMessage("ایمیل کارشناس ردیف "+(Karshnas_Masol_Email+1)+" را وارد نمائید")
    }
    else if(this.RabetMasolCustomer_FeildActivity.length==0)
    {
      this.Alerify.ErrorMessage("حداقل یک زمینه فعالیت  را انتخاب نمائید")
    }
    else if (this.DataList_KarshnasMasol.length==0)
    {
      this.Alerify.ErrorMessage("حداقل یک نماینده کالیبراسیون را انتخاب نمائید")
    }
    else{

      var tempFeild_Activity:Array<number>=[]
      for(let item of this.RabetMasolCustomer_FeildActivity)
      {
        tempFeild_Activity.push(item.id)
      }


      this.Proccesing_OnSubmitForm=true
      var CustomerRecord:Customer_Interface=Empty_Customer_Interface()
      CustomerRecord.id=this.get_Form_id().value
      CustomerRecord.code=this.get_Form_Code().value+""
      CustomerRecord.name=this.get_Form_Name().value
      CustomerRecord.name_en=this.get_Form_Name_En().value
      CustomerRecord.shenasehMeli=this.get_Form_ShenasehMeli().value
      CustomerRecord.city_id=Number(this.get_Form_CityId().value)
      //CustomerRecord.feildActivity_id=Number(this.get_Form_FeildActivity().value)
      CustomerRecord.shomarehSabt=this.get_Form_ShomarehSabt().value
      CustomerRecord.codeEghtesadi=this.get_Form_CodeEghtesadi().value
      CustomerRecord.codeMeli=this.get_Form_CodeMeli().value
      CustomerRecord.modirAmelName=this.get_Form_ModirAmelName().value
      CustomerRecord.modirAmelMobile=this.get_Form_ModirAmelMobile().value
      CustomerRecord.modirAmelTel=this.get_Form_ModirAmelTel().value
      CustomerRecord.modirAmelDakheli=this.get_Form_ModirAmelDakheli().value
      CustomerRecord.modirAmelEmail=this.get_Form_ModirAmelEmail().value
      CustomerRecord.foreign=this.get_Form_Foreign().value=='1'

      this.Customer_Service.AddCustomer(
        CustomerRecord,
        this.DataList_KarshnasMasol,
        this.DataList_Address,
        tempFeild_Activity).subscribe(
        data=>{
          this.Proccesing_OnSubmitForm=false
          if(data.id==-1)
          {
            this.Alerify.ErrorMessage("شناسه ملی وارد شده برای مشتری "+data.name+" ثبت شده است")
          }
          else if(data.id==-2)
          {
            this.Alerify.ErrorMessage("نام مشتری تکراری است")
          }
          else if(data.id==-4)
          {
            this.Alerify.ErrorMessage("کد مشتری تکراری است")
          }
          else if(data.id==-3)
          {
            this.Alerify.ErrorMessage("شناسه ملی را وار نمائید")
          }
          else{
            this.Alerify.SuccessMessage("اطلاعات ثبت شد")

            this.DataList_Address=[]
            this.DataList_KarshnasMasol=[]
            this.DataList_City=[]

            this.AddNewCustomer.reset()
            this.AddressCustomer.reset()

            this.get_Form_ProvinceId().setValue("0")
            this.get_Form_CityId().setValue("0")
            this.get_Form_FeildActivity().setValue("0")
            this.get_Form_Foreign().setValue("0")

            this.get_Form_AddressCustomer_title_id().setValue("0")
          }

        }
      )
    }

  }










}
